"use strict";
// https://github.com/Chia-Network/chia-blockchain/blob/6205d954e8ac2ea40ee7386b1ee3124da21f4c4a/chia/types/blockchain_format/slots.py#L24
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubSlotProofs = exports.RewardChainSubSlot = exports.InfusedChallengeChainSubSlot = exports.ChallengeChainSubSlot = exports.ChallengeBlockInfo = void 0;
const fields_1 = __importDefault(require("./fields"));
const proof_of_space_1 = require("./proof_of_space");
const vdf_1 = require("./vdf");
class ChallengeBlockInfo {
}
__decorate([
    fields_1.default.Object(proof_of_space_1.ProofOfSpace)
], ChallengeBlockInfo.prototype, "proofOfSpace", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Object(vdf_1.VDFInfo))
], ChallengeBlockInfo.prototype, "challengeChainSpVdf", void 0);
__decorate([
    fields_1.default.Bytes(96)
], ChallengeBlockInfo.prototype, "challengeChainSpSignature", void 0);
__decorate([
    fields_1.default.Object(vdf_1.VDFInfo)
], ChallengeBlockInfo.prototype, "challengeChainIpVdf", void 0);
exports.ChallengeBlockInfo = ChallengeBlockInfo;
class ChallengeChainSubSlot {
}
__decorate([
    fields_1.default.Object(vdf_1.VDFInfo)
], ChallengeChainSubSlot.prototype, "challengeChainEndOfSlotVdf", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Bytes(32))
], ChallengeChainSubSlot.prototype, "infusedChallengeChainSubSlotHash", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Bytes(32))
], ChallengeChainSubSlot.prototype, "subepochSummaryHash", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Uint(64))
], ChallengeChainSubSlot.prototype, "newSubSlotIters", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Uint(64))
], ChallengeChainSubSlot.prototype, "newDifficulty", void 0);
exports.ChallengeChainSubSlot = ChallengeChainSubSlot;
class InfusedChallengeChainSubSlot {
}
__decorate([
    fields_1.default.Object(vdf_1.VDFInfo)
], InfusedChallengeChainSubSlot.prototype, "infusedChallengeChainEndOfSlotVdf", void 0);
exports.InfusedChallengeChainSubSlot = InfusedChallengeChainSubSlot;
class RewardChainSubSlot {
}
__decorate([
    fields_1.default.Object(vdf_1.VDFInfo)
], RewardChainSubSlot.prototype, "endOfSlotVdf", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RewardChainSubSlot.prototype, "challengeChainSubSlotHash", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Bytes(32))
], RewardChainSubSlot.prototype, "infusedChallengeChainSubSlotHash", void 0);
__decorate([
    fields_1.default.Uint(8)
], RewardChainSubSlot.prototype, "deficit", void 0);
exports.RewardChainSubSlot = RewardChainSubSlot;
class SubSlotProofs {
}
__decorate([
    fields_1.default.Object(vdf_1.VDFProof)
], SubSlotProofs.prototype, "challengeChainSlotProof", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Object(vdf_1.VDFProof))
], SubSlotProofs.prototype, "infusedChallengeChainSlotProof", void 0);
__decorate([
    fields_1.default.Object(vdf_1.VDFProof)
], SubSlotProofs.prototype, "rewardChainSlotProof", void 0);
exports.SubSlotProofs = SubSlotProofs;
//# sourceMappingURL=slots.js.map